// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".online-status-com {\n  cursor: pointer;\n  margin-right: 10px;\n}\n.online-status-com-item {\n  margin: 0 10px;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
